import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";

const get = (query = "") => {
  return responseFormatter(
    http.get(`/users${query}`, {
      setAuthHeader: true
    })
  );
};

const getWhiteList = (query = "") => {
  return responseFormatter(
    http.get(`/whitelisted-clients${query}`, {
      setAuthHeader: true
    })
  );
};

const patch = (id = "", payload) => {
  return responseFormatter(
    http.patch(`/rc-account/role/${id}`, payload, {
      setAuthHeader: true
    })
  );
};

const exportFile = (exportType, query = "") => {
  return responseFormatter(
    http.get(`/export/${exportType}${query}`, {
      setAuthHeader: true
    })
  );
};

const updateRole = (id, payload = {}) => {
  return responseFormatter(
    http.patch(`/user/${id}`, payload, {
      setAuthHeader: true
    })
  );
};

const UserService = {
  get,
  patch,
  exportFile,
  getWhiteList,
  updateRole
};

export default UserService;